








































































import format from 'date-fns/format'
import Vue from 'vue'
import EditorDialog from '@/components/EditorDialog.vue'
import { imgurApi } from '../core/api'
export default {
  name: 'form-generator',
  props: ['fields', 'properties'],
  data() {
    return {
      loading: {},
      data: {},
      errors: {},
      disabledList: {},
      hiddenList: {},
      contentOptions: {}
    }
  },
  components: {
    EditorDialog
  },
  created() {
    setTimeout(() => {
      let el = document.getElementsByClassName('modal-card-body').item(0).getElementsByTagName('input').item(0)
      if (el) el.focus()
    }, 300)
    this.setupData()
    this.inputChanged()
  },
  methods: {
    openContent(field) {
      this.contentOptions = {
        ...this.contentOptions, 
        [field.property]: {
          title: field.label,
          content: this.data[field.property],
          confirmFn: async (content) => {
            this.data[field.property] = content
            setTimeout(() => {
              this.contentOptions = {
                ...this.contentOptions, 
                [field.property]: null 
              }
            }, 1000)
          }
        }
      }
    },
    setupData() {
      this.data = {}
      for (let field of this.fields) {
        if (field.current) {
          this.data[field.property] = field.current
        } else {
          if (field.type == 'checkbox') {
            this.data[field.property] = false
          } else {
            this.data[field.property] = ''
          }
        }

        this.checkListOptions(field)
        this.checkPropsMutation(field)
      }
      this.$emit('change', this.data)
    },
    inputChanged(property) {
      if (property) {
        let field = this.fields.find(x => x.property == property)
        if (field.inputType == 'number') this.data[property] = Number(this.data[property])
        delete this.errors[property]
        this.errors = {...this.errors}        
        this.checkPropsMutation(field)
      }
      this.$emit('change', this.data)
    },
    checkErrors() {
      let fields = [...this.fields]
      for (let field of this.fields) {
        if (field.required) {
          switch (field.type) {
            default: {
              if (!this.data[field.property]) {
                this.errors = {...this.errors, [field.property]: 'Bắt buộc'}
                continue
              }
              break
            }
          }
          delete this.errors[field.property]
          this.errors = { ...this.errors }
        }
      }
      return !!Object.keys(this.errors).length
    },
    onListInputChanged(property, event) {
      if (event.target.value) {
        let field = this.fields.find(x => x.property == property)
        this.data = {...this.data, [property]: [...this.data[property], event.target.value]}
        if (field.options) {
          let option = field.options.find(x => x.code == event.target.value)
          if (option) option.hidden = true
        }
        event.target.value = ''
        this.inputChanged()
      }
    },
    removeFromList(property, index) {
      let removed = this.data[property].splice(index, 1)
      this.data = {...this.data, [property]: [...this.data[property]]}
      let field = this.fields.find(x => x.property == property)
      if (field.options) {
        let option = field.options.find(x => x.code == removed[0])
        if (option) option.hidden = false
      }
      this.inputChanged()
    },
    dateFormatter(date) {
      return format(date, 'dd-MM-yyyy')
    },
    checkListOptions(field) {
      if (field.type == 'list' && field.options) {
        field.optionsObj = field.options.reduce((current, item) => { current[item.code] = item.display; return current }, {})
      }
    },
    checkPropsMutation(field) {
      if (field.propsMutation) {
        let conditionRes = field.propsMutation.conditionFn(this.data[field.property])
        if (field.propsMutation.type == 'disabled') {            
          field.propsMutation.properties.forEach(prop => this.disabledList = {...this.disabledList, [prop]: conditionRes})
        } else {
          field.propsMutation.properties.forEach(prop => this.hiddenList = {...this.hiddenList, [prop]: conditionRes})
        }
      }
    },
    async onImageChanged(event, field) {
      let files = event.target.files
      let file = files[0]
      if (file) {
        this.loading = {...this.loading, [field.property]: true }
        let res = await imgurApi.uploadImg(file)
        this.data = { ... this.data, [field.property]: res.data.link }
        this.loading = {...this.loading, [field.property]: false }
        event.target.value = ''
        this.inputChanged(field.property)
      }
    }
  }
}
